import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
// redirect,
import Auth from '../../Helpers/auth';
import PropTypes from 'prop-types';

export const AuthCheckUser = ({ children }) => {
  // const navigate = useNavigate();
  const [isAuth, setIsAuth] = useState(true);
  const { data } = Auth.getProfile();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!Auth.loggedIn() || Auth.checkTokenOnLoad()) {
      setIsAuth(false);
    }
  }, [data]);
  if (!isAuth) {
    return <Navigate to="login" replace />;
  }
  return children;
};

AuthCheckUser.propTypes = {
  children: PropTypes.node.isRequired,
};
